import { render, staticRenderFns } from "./BCard.vue?vue&type=template&id=342344c6&scoped=true&"
import script from "./BCard.vue?vue&type=script&lang=js&"
export * from "./BCard.vue?vue&type=script&lang=js&"
import style0 from "./BCard.vue?vue&type=style&index=0&id=342344c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342344c6",
  null
  
)

export default component.exports